<template>
  <div class="com-aonaer-admin-cusinfo-add-container">
    <!-- 页面标题 -->
    <div class="com-aonaer-admin-cusinfo-add-page-header">
      <div class="com-aonaer-admin-cusinfo-add-page-title">添加客户</div>
      <a href="#" class="com-aonaer-admin-cusinfo-add-page-back-btn" @click.prevent="jumpToPage('客户管理', {}, {})">
        ← 返回客户列表
      </a>
    </div>

    <!-- 自定义字段按钮 -->
    <button class="com-aonaer-admin-cusinfo-add-custom-field-btn" @click="openCustomFieldModal">
      添加自定义字段
    </button>
    <h2 class="com-aonaer-admin-cusinfo-add-form-group-title">基础信息</h2>
    <MyForm style="margin-top: 5px;padding: 0 5px;">
      <MyFormItem style="width:calc(50% - 7.5px);" label="客户名称" required>
        <el-input v-model="addForm.name" placeholder="请输入客户名称" style="width:100%;" clearable></el-input>
      </MyFormItem>
      <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="联系方式" required>
        <el-input v-model="addForm.phone" placeholder="请输入客户联系方式" maxLength="11" style="width:100%;"
          clearable></el-input>
      </MyFormItem>
      <MyFormItem style="width:calc(50% - 7.5px);" label="邮箱">
        <el-input v-model="addForm.email" placeholder="请输入客户邮箱" style="width:100%;" clearable></el-input>
      </MyFormItem>
      <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" style="margin-top: 20px;">公司信息</h2>
      <MyFormItem style="width:calc(50% - 7.5px);" label="公司名称">
        <el-input v-model="addForm.com" placeholder="请输入客户所属公司" style="width:100%;" clearable></el-input>
      </MyFormItem>
      <MyFormItem label="所属国家" style="width:calc(50% - 7.5px);margin-left: 15px;">
        <el-cascader style="width:100%;" :props="{ checkStrictly: true }" filterable :options="areaOptions"
          v-model="addForm.country" clearable>
        </el-cascader>
      </MyFormItem>
      <MyFormItem label="宗教信息" style="width:calc(50% - 7.5px);">
        <el-input v-model="addForm.religion" placeholder="请输入客户宗教信息" style="width:100%;" clearable></el-input>
      </MyFormItem>
      <MyFormItem label="客户地址" style="width:calc(50% - 7.5px);margin-left: 15px;">
        <el-input v-model="addForm.area" placeholder="请输入客户地址信息" style="width:100%;" clearable></el-input>
      </MyFormItem>
      <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" style="margin-top: 20px;">其他信息</h2>
      <MyFormItem label="客户来源" style="width:calc(50% - 7.5px);" required>
        <el-select v-model="addForm.srce" style="width:100%;" filterable placeholder="请选择客户来源">
          <el-option
            v-for="(item, index) in ['阿里巴巴', '中国制造', '独立站', '公司展会', '集团客户', '亚马逊', '脸书', '广交会', '环球资源', '社交媒体', '速卖通', '其他来源']"
            :key="index" :label="item" :value="index">
          </el-option>
        </el-select>
      </MyFormItem>
      <MyFormItem label="客户评级" style="width:calc(50% - 7.5px);margin-left: 15px;" required>
        <el-select v-model="addForm.rating" style="width:100%;" filterable placeholder="请选择客户评级">
          <el-option v-for="(item, index) in ['优质客户', '高级客户', '中级客户', '低级客户', '垃圾客户']" :key="index" :label="item"
            :value="index">
          </el-option>
        </el-select>
      </MyFormItem>
      <MyFormItem v-show="userInfo?.user?.member == 0" style="width:calc(50% - 7.5px);" label="客户类型" required>
        <el-select v-model="addForm.pid" style="width:100%;" filterable placeholder="请选择客户类型">
          <el-option v-for="(item, index) in [{
            label: '个人客户',
            value: 0
          }, {
            label: '公海客户',
            value: 1
          }]" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </MyFormItem>
      <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" v-if="customFields.length > 0"
        style="margin-top: 20px;">自定义信息</h2>
      <MyFormItem v-for="(field, index) in customFields" :key="index" style="width:calc(50% - 7.5px);"
        :style="{ 'margin-left': index % 2 == 0 ? '0px' : '15px' }" :label="field.name">
        <el-input v-if="field.type === 'string'" v-model="field.value" :placeholder="`请输入${field.name}`"
          style="width:100%;" clearable></el-input>
        <MyUpload v-if="field.type === 'file'" v-model="field.value" :limit="10" size="100px"></MyUpload>
        <el-date-picker v-if="field.type === 'date'" v-model="field.value" style="width:100%" type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
        <div class="com-aonaer-admin-cusinfo-add-form-item-btn iconfont" @click="deleteItem(index)">
          &#xEC2A;
        </div>
      </MyFormItem>
    </MyForm>
    <!-- 表单主体 -->

    <!-- 按钮区域 -->
    <div class="com-aonaer-admin-cusinfo-add-btn-group">
      <button type="button" class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-secondary"
        @click="jumpToPage('客户管理', {}, {})">取消</button>
      <button type="button" class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-primary"
        @click="addCusInfoFuc()">添加</button>
    </div>

    <!-- 自定义字段弹窗 -->
    <div class="com-aonaer-admin-cusinfo-add-modal" v-if="isModalOpen" @click="closeCustomFieldModal">
      <div class="com-aonaer-admin-cusinfo-add-modal-content" @click.stop>
        <h3 class="com-aonaer-admin-cusinfo-add-modal-title">添加自定义字段</h3>
        <div class="com-aonaer-admin-cusinfo-add-form-item">
          <label class="com-aonaer-admin-cusinfo-add-form-label">字段名称 <span
              class="com-aonaer-admin-cusinfo-add-required">*</span></label>
          <input type="text" class="com-aonaer-admin-cusinfo-add-form-control"
            :class="{ 'com-aonaer-admin-cusinfo-add-error': !!modalError }" v-model="modalFieldName"
            placeholder="请输入字段名称">
          <div class="com-aonaer-admin-cusinfo-add-error-message" v-if="modalError">{{ modalError }}</div>
        </div>
        <div class="com-aonaer-admin-cusinfo-add-form-item">
          <label class="com-aonaer-admin-cusinfo-add-form-label">数据类型 <span
              class="com-aonaer-admin-cusinfo-add-required">*</span></label>
          <select class="com-aonaer-admin-cusinfo-add-form-control" v-model="modalFieldType">
            <option value="string">字符串（文本输入）</option>
            <option value="file">文件上传</option>
            <!-- <option value="number">数字</option> -->
            <option value="date">日期</option>
          </select>
        </div>
        <div class="com-aonaer-admin-cusinfo-add-modal-footer">
          <button type="button" class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-secondary"
            @click="closeCustomFieldModal">取消</button>
          <button type="button" class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-primary"
            @click="confirmAddCustomField">确认添加</button>
        </div>
      </div>
    </div>

    <!-- 提示消息框 -->
    <div class="com-aonaer-admin-cusinfo-add-toast" :class="{
      'com-aonaer-admin-cusinfo-add-toast-success': toastConfig.type === 'success',
      'com-aonaer-admin-cusinfo-add-toast-error': toastConfig.type === 'error',
      'com-aonaer-admin-cusinfo-add-toast-show': toastConfig.show
    }">
      {{ toastConfig.message }}
    </div>
  </div>
</template>

<script>
import areaData from '@/../public/data/data2.json';
import { mapState } from 'vuex';
import MyForm from '@/components/MyForm';
import MyFormItem from '@/components/MyForm/MyFormItem';
import { jumpTo } from '@/utils/myutils';
import MyUpload from '@/components/MyUpload';
import { addCusInfo, addCusInfo2 } from '@/api';
export default {
  name: 'ComAonaerAdminCusinfoAdd',
  data() {
    return {
      areaOptions: areaData,
      addForm: {
        pid: 0,
        com: '',
        area: '',
        name: '',
        phone: '',
        email: '',
        country: '',
        religion: '',
        rating: 0,
        srce: 0
      },
      // 表单数据
      formData: {
        customerType: '',
        customerName: '',
        country: '',
        customerLevel: '',
        customerSource: '',
        contactName: '',
        email: '',
        phoneCode: '+86',
        phoneNumber: '',
        backupPhone: '',
        socialAccounts: '',
        address: '',
        customFields: [] // 存储自定义字段值，文件类型存储文件对象/路径，其他存储文本值
      },
      // 错误信息
      errors: {},
      // 自定义字段列表
      customFields: [
        {
          name: "客户生日",
          type: "date",
          typeText: "日期",
          value: ""
        },
        {
          name: "客户公司职位",
          type: "string",
          typeText: "字符串（文本输入）",
          value: ""
        }
      ],
      // 弹窗状态
      isModalOpen: false,
      modalFieldName: '',
      modalFieldType: 'string',
      modalError: '',
      // 提示框配置
      toastConfig: {
        show: false,
        message: '',
        type: 'success' // success/error
      }
    }
  },
  components: {
    MyForm,
    MyFormItem,
    MyUpload
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    async addCusInfoFuc() {
      if (this.addForm.name == null || this.addForm.name == '') {
        this.$message.error('请输入客户名称！');
        return;
      }
      if (this.addForm.phone == null || this.addForm.phone == '') {
        this.$message.error('客户联系方式未填写或格式不正确！');
        return;
      }
      if (this.addForm.pid === null || this.addForm.pid === '') {
        this.$message.error('请选择客户类型！');
        return;
      }
      if (this.addForm.email !== null && this.addForm.email !== '') {
        if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.addForm.email)) {
          this.$message.error('请输入正确的邮箱格式！');
          return;
        }
      }
      if (this.addForm.rating === null || this.addForm.rating === '') {
        this.$message.error('请选择客户评级！');
        return;
      }
      if (this.addForm.srce === null || this.addForm.srce === '') {
        this.$message.error('请选择客户来源！');
        return;
      }
      this.addForm.country && (this.addForm.country = this.addForm.country.join('/'));
      const extInfo = JSON.parse(JSON.stringify(this.customFields));
      extInfo.forEach(item => {
        if (item.type === 'file') {
          item.value = item.value.join(',');
        }
      });
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = await addCusInfo2({
        cusInfo: this.addForm,
        extInfo: extInfo
      });
      loading.close();
      if (data.code == 200) {
        this.$message.success('客户创建成功！');
        // setTimeout(() => {
        //   this.jumpToPage('客户管理', {}, {});
        // }, 500);
      } else {
        if (data.code == 401) return;
        this.$message.error(data.message);
      }
    },
    // 删除自定义字段
    deleteItem(index) {
      delete this.addForm[this.customFields[index].name];
      this.customFields.splice(index, 1);
    },
    jumpToPage(pageName, query, params) {
      jumpTo(this, pageName, query, params);
    },

    // 处理文件上传字段的变化
    handleFileChange(event, index) {
      const file = event.target.files[0];
      if (file) {
        // 这里可以根据实际需求处理文件：比如存储文件对象、文件名、或者上传到服务器
        this.formData.customFields[index] = file;
        // 如果需要仅存储文件名：this.formData.customFields[index] = file.name;
      }
    },

    // 验证单个字段
    validateField(fieldName) {
      const value = this.formData[fieldName]?.trim() || '';
      this.errors[fieldName] = '';

      // 必填字段验证
      const requiredFields = [
        'customerType', 'customerName', 'country',
        'customerLevel', 'customerSource', 'contactName',
        'email', 'phoneNumber'
      ];

      if (requiredFields.includes(fieldName) && !value) {
        if (fieldName === 'email') {
          this.errors[fieldName] = '请输入邮箱地址';
        } else if (fieldName === 'phoneNumber') {
          this.errors[fieldName] = '请输入手机号码';
        } else {
          this.errors[fieldName] = `请${fieldName === 'customerType' ? '选择' : '输入'}${this.getFieldLabel(fieldName)}`;
        }
        return false;
      }

      // 邮箱格式验证
      if (fieldName === 'email' && value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          this.errors[fieldName] = '请输入正确的邮箱格式';
          return false;
        }
      }

      // 手机号格式验证
      if (fieldName === 'phoneNumber' && value) {
        const phoneRegex = /^[0-9]{8,15}$/;
        if (!phoneRegex.test(value)) {
          this.errors[fieldName] = '请输入8-15位的手机号码';
          return false;
        }
      }

      return true;
    },

    // 完整表单验证
    validateForm() {
      let isValid = true;
      const requiredFields = [
        'customerType', 'customerName', 'country',
        'customerLevel', 'customerSource', 'contactName',
        'email', 'phoneNumber'
      ];

      // 验证所有必填字段
      requiredFields.forEach(field => {
        if (!this.validateField(field)) {
          isValid = false;
        }
      });

      // 聚焦到第一个错误字段
      if (!isValid) {
        const firstErrorField = Object.keys(this.errors).find(key => this.errors[key]);
        if (firstErrorField) {
          const el = document.querySelector(`[v-model="formData.${firstErrorField}"]`);
          if (el) el.focus();
        }
      }

      return isValid;
    },

    // 获取字段中文标签
    getFieldLabel(fieldName) {
      const labelMap = {
        customerType: '客户类型',
        customerName: '客户名称',
        country: '所属国家/地区',
        customerLevel: '客户等级',
        customerSource: '客户来源',
        contactName: '主要联系人姓名',
        email: '邮箱地址',
        phoneNumber: '手机号码'
      };
      return labelMap[fieldName] || fieldName;
    },

    // 显示提示消息
    showToast(message, type = 'success') {
      this.toastConfig = {
        show: true,
        message,
        type
      };

      setTimeout(() => {
        this.toastConfig.show = false;
      }, 3000);
    },

    // 保存客户信息
    handleSave() {
      this.addCusInfoFuc();
    },

    // 重置表单
    resetForm() {
      this.formData = {
        customerType: '',
        customerName: '',
        country: '',
        customerLevel: '',
        customerSource: '',
        contactName: '',
        email: '',
        phoneCode: '+86',
        phoneNumber: '',
        backupPhone: '',
        socialAccounts: '',
        address: '',
        customFields: Array(this.customFields.length).fill('')
      };
      this.errors = {};
    },

    // 取消操作
    handleCancel() {
      if (confirm('确定要取消添加客户吗？已填写的信息将不会保存。')) {
        // 实际项目中使用 $router.push 跳转
        // this.$router.push('/customer-list');
        alert('将跳转到客户列表页');
      }
    },

    // 打开自定义字段弹窗
    openCustomFieldModal() {
      this.isModalOpen = true;
      this.modalFieldName = '';
      this.modalFieldType = 'string';
      this.modalError = '';
    },

    // 关闭自定义字段弹窗
    closeCustomFieldModal() {
      this.isModalOpen = false;
      this.modalError = '';
    },

    // 确认添加自定义字段
    confirmAddCustomField() {
      const fieldName = this.modalFieldName.trim();

      if (!fieldName) {
        this.modalError = '请输入字段名称';
        return;
      }

      // 获取数据类型文本
      const typeTextMap = {
        string: '字符串（文本输入）',
        file: '文件上传',
        number: '数字',
        date: '日期'
      };

      // 添加自定义字段
      this.customFields.push({
        name: fieldName,
        type: this.modalFieldType,
        typeText: typeTextMap[this.modalFieldType],
        value: this.modalFieldType === 'file' ? [] : ''
      });

      // 初始化自定义字段值
      this.formData.customFields.push('');

      // 关闭弹窗
      this.closeCustomFieldModal();
      this.showToast('自定义字段添加成功');
    }
  }
};
</script>

<style>
.com-aonaer-admin-cusinfo-add-page-header {
  height: fit-content;
  width: 100%;
  position: relative;
  float: left;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  margin-bottom: 30px !important;
  padding: 20px 0 !important;
}

.com-aonaer-admin-cusinfo-add-page-back-btn {
  position: relative;
  float: right;
  text-decoration: none;
  color: #333;
}

/* 全局样式重置 */
.com-aonaer-admin-cusinfo-add-container * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.com-aonaer-admin-cusinfo-add-container {
  background-color: #f5f7fa;
  color: #333;
  line-height: 1.6;
  /* min-height: 100vh; */
  padding: 20px;
}

/* 页面容器 */
.com-aonaer-admin-cusinfo-add-container {
  /* max-width: 1200px; */
  height: calc(100vh - 50px) !important;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow-y: auto;
}

/* 页面标题 */
.com-aonaer-admin-cusinfo-add-page-title {
  width: fit-content;
  font-size: 22px;
  font-weight: 600;
  position: relative;
  float: left;
}

/* 表单布局 */
.com-aonaer-admin-cusinfo-add-form-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .com-aonaer-admin-cusinfo-add-form-wrapper {
    grid-template-columns: 1fr;
  }
}

/* 表单分组 */
.com-aonaer-admin-cusinfo-add-form-group {
  margin-bottom: 20px;
}

.com-aonaer-admin-cusinfo-add-form-group-title {
  width: 100%;
  height: fit-content;
  position: relative;
  float: left;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #222;
  padding-left: 5px;
  border-left: 3px solid #007bff;
}

/* 表单项 */
.com-aonaer-admin-cusinfo-add-form-item {
  margin-bottom: 15px;
}

.com-aonaer-admin-cusinfo-add-form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
}

.com-aonaer-admin-cusinfo-add-required {
  color: #dc3545;
  margin-left: 3px;
}

.com-aonaer-admin-cusinfo-add-form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

/* 适配文件上传控件的样式 */
input[type="file"].com-aonaer-admin-cusinfo-add-form-control {
  padding: 3px 12px;
  height: auto;
}

.com-aonaer-admin-cusinfo-add-form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

textarea.com-aonaer-admin-cusinfo-add-form-control {
  min-height: 80px;
  resize: vertical;
}

/* 错误提示 */
.com-aonaer-admin-cusinfo-add-error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
  display: none;
}

.com-aonaer-admin-cusinfo-add-error {
  border-color: #dc3545 !important;
}

.com-aonaer-admin-cusinfo-add-error+.com-aonaer-admin-cusinfo-add-error-message {
  display: block;
}

/* 国旗下拉框样式 */
.com-aonaer-admin-cusinfo-add-country-select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23333' viewBox='0 0 16 16'%3E%3Cpath d='M8 11.5l-6-6 1.5-1.5L8 8.5l4.5-4.5L14 5.5l-6 6z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 30px;
}

/* 自定义字段按钮 */
.com-aonaer-admin-cusinfo-add-custom-field-btn {
  padding: 8px 15px;
  background-color: #6c757d;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 20px;
  transition: background-color 0.2s;
}

.com-aonaer-admin-cusinfo-add-custom-field-btn:hover {
  background-color: #5a6268;
}

/* 按钮区域 */
.com-aonaer-admin-cusinfo-add-btn-group {
  width: 100%;
  position: relative;
  float: right;
  display: flex;
  gap: 15px;
  margin-top: 30px;
  justify-content: flex-end;
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: 1px solid #eee;
}

.com-aonaer-admin-cusinfo-add-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.com-aonaer-admin-cusinfo-add-btn-primary {
  background-color: #007bff;
  color: #fff;
}

.com-aonaer-admin-cusinfo-add-btn-primary:hover {
  background-color: #0069d9;
}

.com-aonaer-admin-cusinfo-add-btn-secondary {
  background-color: #6c757d;
  color: #fff;
}

.com-aonaer-admin-cusinfo-add-btn-secondary:hover {
  background-color: #5a6268;
}

/* 弹窗样式 */
.com-aonaer-admin-cusinfo-add-modal {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  justify-content: center;
  align-items: center;
}

.com-aonaer-admin-cusinfo-add-modal-content {
  background-color: #fff;
  padding: 25px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.com-aonaer-admin-cusinfo-add-modal-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.com-aonaer-admin-cusinfo-add-modal-footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

/* 提示消息 */
.com-aonaer-admin-cusinfo-add-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 15px 25px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  z-index: 1001;
  opacity: 0;
  transform: translateY(-20px);
  transition: all 0.3s ease;
}

.com-aonaer-admin-cusinfo-add-toast-show {
  opacity: 1;
  transform: translateY(0);
}

.com-aonaer-admin-cusinfo-add-toast-success {
  background-color: #28a745;
}

.com-aonaer-admin-cusinfo-add-toast-error {
  background-color: #dc3545;
}

/* 区号选择框 */
.com-aonaer-admin-cusinfo-add-phone-wrapper {
  display: flex;
  gap: 10px;
}

.com-aonaer-admin-cusinfo-add-phone-code {
  width: 100px;
}

.com-aonaer-admin-cusinfo-add-phone-number {
  flex: 1;
}

.com-aonaer-admin-cusinfo-add-form-item-btn {
  height: 28px;
  width: 28px;
  position: absolute;
  margin: auto;
  top: 30px;
  bottom: 0;
  right: 10px;
  line-height: 28px;
  text-align: center;
  background: #EEE;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  transition: .3s;
  cursor: pointer;
  user-select: none;
}

.com-aonaer-admin-cusinfo-add-form-item-btn:hover {
  background: #ff5656;
}
</style>